import { Select } from 'antd';
import './Select.css';
import classNames from 'classnames';
import PropTypes from 'prop-types';

export const CustomSelect = ({ className, borderless, ...props }) => {
    return (
        <Select
            {...props}
            className={classNames('custom-select', borderless && 'custom-borderless-select', className)}
        />
    );
};

CustomSelect.propTypes = {
    className: PropTypes.string,
    borderless: PropTypes.bool,
};
